import { createRouter, createWebHistory } from 'vue-router';
import Login from '../components/login_acceso.vue';
import HomeInicio from '../components/HomeInicio.vue';
import Register from '../components/registro_usuario.vue'; // Importa el componente de registro
import AltaDeInventario from "../components/altainventario.vue"; // Importa el componente
import VerStock from '../components/verstock.vue'; // Importa el nuevo componente VerStock
import rentasvestido from '../components/rentasvestido.vue'; // Importa el nuevo componente VerStock
import Ingresosrenta from '@/components/IngresoRentaForm.vue';
import Egresosrenta from '@/components/egresosRenta.vue';
import calendario from '@/components/calendario.vue';
import estadisticas from '@/components/estadisticas.vue';
import historial from '@/components/historial-vue.vue';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: "/home",
    name: "HomeInicio",
    component: HomeInicio,
    children: [
      {
        path: "altainventario", // Ruta para Alta de Inventario
        name: "inventory",
        component: AltaDeInventario,
      },
      {
        path: "verstock", // Ruta para Ver Stock
        name: "stock",
        component: VerStock,
      },
      {
        path: "rentasvestido", // Ruta para Ver Stock
        name: "rentas",
        component: rentasvestido,
      },
      {
        path: "Ingresosrenta", // Ruta para Ver Stock
        name: "ingresos",
        component: Ingresosrenta,
      },
      {
        path: "Egresosrenta", // Ruta para Ver Stock
        name: "egresos",
        component: Egresosrenta,
      },
      {
        path: "calendario", // Ruta para Ver Stock
        name: "calendario",
        component: calendario,
      },
      {
        path: "historial", // Ruta para Ver Stock
        name: "historial",
        component: historial,
      },

      {
        path: "estadisticas", // Ruta para Ver Stock
        name: "estadisticas",
        component: estadisticas,
      },
    ],
  },
  // Puedes añadir más rutas aquí si es necesario
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
